import React from "react";

import Container from "../Container";
import RichtextRenderer from "../RichtextRenderer";

import ConstructionWorkerImage from "../../assets/page/construction-worker.svg";
import KeyImage from "../../assets/page/key.svg";
import BuildingImage from "../../assets/page/building.svg";
import PartnershipImage from "../../assets/page/partnership.svg";
import PresentationImage from "../../assets/page/presentation.svg";
import FormulaImage from "../../assets/page/fx.svg";

const MarketPositionItem = ({ title, description, icon }) => {
  return (
    <div className="flex flex-col">
      <img src={icon} alt={`${title}`} className="w-36px h-36px icon" />
      <div className="text-gold data-text font-bold text-18px leading-6 font-lato">{title}</div>
      <p className="text-blue text-18px leading-6 font-lato">{description}</p>
    </div>
  );
};
const MarketPositionSection = ({
  marketPositionTitle,
  marketPositionSubtitle,
  marketPositionText,
  marketPositionItem1Title,
  marketPositionItem1Description,
  marketPositionItem2Title,
  marketPositionItem2Description,
  marketPositionItem3Title,
  marketPositionItem3Description,
  marketPositionItem4Title,
  marketPositionItem4Description,
  marketPositionItem5Title,
  marketPositionItem5Description,
  marketPositionItem6Title,
  marketPositionItem6Description,
}) => {
  return (
    <Container innerContainerClassName="relative bg-white" additionalPx>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-64px">
        <div className="flex flex-col">
          <div>
            <h2 className="text-gold text-32px leading-10">{marketPositionTitle}</h2>
            {/*<h3 className="font-bold text-24px leading-8">{marketPositionSubtitle}</h3>*/}
          </div>
          <RichtextRenderer data={marketPositionText} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-24px">
          <MarketPositionItem
            title={marketPositionItem1Title}
            description={marketPositionItem1Description}
            icon={ConstructionWorkerImage}
          />
          <MarketPositionItem
            title={marketPositionItem2Title}
            description={marketPositionItem2Description}
            icon={KeyImage}
          />
          <MarketPositionItem
            title={marketPositionItem3Title}
            description={marketPositionItem3Description}
            icon={BuildingImage}
          />
          <MarketPositionItem
            title={marketPositionItem4Title}
            description={marketPositionItem4Description}
            icon={PartnershipImage}
          />
          <MarketPositionItem
            title={marketPositionItem5Title}
            description={marketPositionItem5Description}
            icon={PresentationImage}
          />
          <MarketPositionItem
            title={marketPositionItem6Title}
            description={marketPositionItem6Description}
            icon={FormulaImage}
          />
        </div>
      </div>
    </Container>
  );
};
export default MarketPositionSection;
